<template>
  <a-layout class="login">
    <a-layout-header>
      <div class="full-height flex flex-item-center">
        <div class="flex-space">
          <span class="logo-w">
            <img class="logo" src="../assets/images/meituan.png"/>
            <span class="logo-name">美团外卖</span>
            <span class="name">商家中心</span>
          </span>
        </div>
        <div class="flex flex-item-center" style="padding-right: 20px;color: #3f4156">
          <icon-font :size="18" type="icon-xiazai"></icon-font>
          <span>电脑端下载</span>
          <icon-font :size="14" style="margin-left: 20px" type="icon-kehu"></icon-font>
          <span>手机客户端</span>
        </div>
      </div>
    </a-layout-header>
    <a-layout-content>
      <div style="margin: 100px auto 0 auto">
        <div style="width: 416px;margin: auto">
          <div style="padding: 32px">
            <div class="ep-tab">
              <div :class="{active: active === 1}" class="ep-tab-item" @click="changeTab(1)">
                <div>账号登录</div>
                <div v-show="active === 1" class="ep-tab_bar" style="background: rgb(255, 209, 0);"></div>
              </div>
              <div :class="{active: active === 2}" class="ep-tab-item" @click="changeTab(2)">
                <div>验证码登录</div>
                <div v-show="active === 2" class="ep-tab_bar" style="background: rgb(255, 209, 0);"></div>
              </div>
            </div>
            <div style="min-height: 325px">
              <a-form :model="form" auto-label-width size="large" @submit="handleSubmit">
                <template v-if="active === 1">
                  <a-form-item field="username" style="margin-bottom: 0">
                    <a-input v-model="form.username" allow-clear placeholder="输入账号">
                      <template #prefix>
                        <icon-user :size="18"/>
                      </template>
                    </a-input>
                  </a-form-item>
                  <a-form-item field="password" style="margin-bottom: 0">
                    <a-input-password v-model="form.password" allow-clear placeholder="输入密码">
                      <template #prefix>
                        <icon-lock :size="18"/>
                      </template>
                    </a-input-password>
                  </a-form-item>
                  <div class="ep-login_bottom">
                    <div class="ep-forget">
                      <a class="link highlightColor"
                         href="https://waimaie.meituan.com/new_fe/login_gw#/recover" rel="noreferrer"
                         target="">忘记账号/密码</a>
                    </div>
                  </div>
                </template>
                <template v-if="active === 2">
                  <a-form-item field="username" style="margin-bottom: 0">
                    <a-input allow-clear placeholder="输入手机号">
                      <template #prefix>
                        <icon-mobile :size="20" style="margin-right: 10px"/>
                        <a-dropdown :popup-max-height="false">
                          <span>+86<icon-down/></span>
                          <template #content>
                            <a-doption>+86(中国)</a-doption>
                            <a-doption>+65(新加坡)</a-doption>
                            <a-doption>+852(中国香港)</a-doption>
                            <a-doption>+853(中国澳门)</a-doption>
                          </template>
                        </a-dropdown>
                      </template>
                    </a-input>
                  </a-form-item>
                  <a-form-item field="password" style="margin-bottom: 0">
                    <a-input allow-clear placeholder="输入验证码">
                      <template #prefix>
                       <span>验证码</span>
                      </template>
                      <template #suffix>
                        <span style="color: #ff6000;font-size: 14px;cursor: pointer;margin-left: 10px">获取验证码</span>
                      </template>
                    </a-input>
                  </a-form-item>
                  <div class="ep-login_bottom">
                    <a class="link highlightColor" href="https://epassport.meituan.com/portal/changephone/info?feconfig=waimai&amp;bg_source=3&amp;service=waimai&amp;biz_line=12&amp;continue=https://waimaie.meituan.com/new_fe/login_gw#/login"
                       rel="noreferrer"
                       target="_blank">手机号不可用</a>
                  </div>
                </template>
                <div class="ep-protocol">
                  <a-checkbox v-model="hasRead">
                    <span class="ep-authorize">我已阅读并同意</span>
                    <a class="protocol-link highlightColor"
                       href="https://rules-center.meituan.com/m/detail/guize/172?activeRule=1&amp;commonType=6"
                       rel="noopener noreferrer" target="_blank">《美团外卖商家隐私协议》</a>
                  </a-checkbox>
                </div>
                <a-button long size="large" html-type="submit"
                          style="background-color: #ffd100;padding: 2px 19px;border-radius: 4px;color: #222222">登录
                </a-button>
              </a-form>
              <div class="ep-login_bottompanel">
                <div class="signup-link">
                  <a class="link" href="https://waimaie.meituan.com/new_fe/login_gw#/signup"
                     rel="noreferrer" style="color: rgb(255, 96, 0);"
                     target="">注册账号，免费入驻</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import {login} from "@/assets/api";

export default {
  name: `Login`,
  data() {
    return {
      active: 1,
      form: {
        username: '',
        password: ''
      },
      hasRead: false
    }
  },
  methods: {
    changeTab(i) {
      this.active = i
    },
    handleSubmit() {
      if (!this.hasRead) {
        this.$message.warning('请先勾选底部协议')
        return
      }
      login(this.form).then(res => {
        if (res.code == 200) {
          localStorage.setItem('m-token', res.data[0].access_token)
          this.$router.push('/home')
        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        this.$message.error(res.message)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  height: 100%;
  width: 100%;

  :deep(.arco-layout-header) {
    height: 60px;
    box-shadow: 0 2px 6px 0 #f1f1f6;
  }

  :deep(.arco-input-wrapper) {
    height: 60px;
    background: #fff;
    border: 0;
    border-bottom: 1px solid #eeeeee;

    &:focus-within, &.arco-input-focus {
      border: 0;
      border-bottom: 1px solid #ffd100;
    }
  }
  :deep(.arco-input) {
    width: 300px;
  }

  .logo-w {
    display: flex;
    font-size: 14px;
    align-items: center;
    color: #3f4156;
  }

  .logo {
    height: 20px;
    margin-left: 25px;
  }
  .logo-name{
    font-size: 15px;
    margin-left: 6px;
    margin-right: 6px;
    font-weight: bold;
  }
  .name {
    &:before {
      display: inline-block;
      margin: 0 6px;
      width: 1px;
      height: 12px;
      vertical-align: middle;
      background-color: #a2a4b3;
      content: "";
    }
  }

  .ep-tab {
    display: flex;
    -ms-flex-direction: row;
    flex-direction: row;
    margin-bottom: 20px;
  }

  .ep-tab-item {
    font-weight: 400;
    font-size: 18px;
    color: #666666;
    line-height: 18px;
    margin-right: 48px;
    padding-bottom: 8px;
    cursor: pointer;

    &.active {
      font-weight: 500;
      color: #222222;
    }
  }

  .ep-tab_bar {
    margin-top: 8px;
    height: 4px;
    width: auto;
    border-radius: 2px;
  }

  .ep-login_bottom {
    display: flex;
    margin-top: 15px;
    flex-direction: row-reverse;

    .ep-forget {
      display: flex;
      flex-direction: row-reverse;
    }

    .link {
      font-size: 14px;
      color: #666666;
      line-height: 14px;
      text-decoration: none;
      padding-right: 11px;
    }
  }

  .ep-protocol {
    margin-top: 42px;
    margin-bottom: 13px;

    a.protocol-link {
      color: #999999;
      text-decoration: none;
    }
  }

  .ep-authorize {
    font-size: 14px;
    color: #999999;
    line-height: 24px;
    text-align: left;
    margin-left: 8px;
  }

  .ep-login_bottompanel {
    padding-top: 10px;
    display: -ms-flexbox;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .signup-link {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
    }
  }
}
</style>